import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { Image_URL, privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import CustomImage from "../CustomImage/CustomImage";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

function ServiceShortcutHeading() {
  const [Heading, setHeading] = useState("");
  const [SubHeading, setSubHeading] = useState("");
  const [visible, setVisible] = useState("");
  const [positionBGColor, setPositionBGColor] = useState("");
  const [marginTop, setMarginTop] = useState(0);
  const [marginBottom, setMarginBottom] = useState(0);
  const [paddingBottom, setPaddingBottom] = useState(0);
  const [paddingTop, setPaddingTop] = useState(0);
  const [gettservice, setGettService] = useState([]);
  const [headingColor, setheadingColor] = useState("#ffffff");
  const [color, setColor] = useState("#ffffff");
  const [showModal, setShowModal] = useState(false);
  const [Status, setStatus] = useState("");
  const [editItemId, setEditItemId] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const [imagePreview, setImagePreview] = useState();
  const [items, setItems] = useState(gettservice);
  const [itemss, setItemss] = useState();

  const getServiceShorcutHeading = async () => {
    try {
      const response = await privateRequest.get(
        `ServiceShortcutHeading/ShortcutHeading`
      );
      console.log("response?.data?.data", response?.data?.data);
      const sortedData = response?.data?.data.sort((a, b) => a.Index - b.Index);
      setGettService(sortedData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteService = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `ServiceShortcutHeading/ShortcutHeading/${_id}`
        );
        getServiceShorcutHeading();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  console.log("selectedFile", selectedFile);
  console.log("imagePreview", imagePreview);

  const AddServiceShortcutHeading = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("Heading", Heading);
      formData.append("SubHeading", SubHeading);
      formData.append("Status", Status);
      formData.append("BackGroundColour", color);
      formData.append("Visible", visible);
      formData.append("marginBottom", marginBottom);
      formData.append("paddingTop", paddingTop);
      formData.append("paddingBottom", paddingBottom);
      formData.append("marginTop", marginTop);
      // formData.append(
      //   "BackGroundImages",
      //   selectedFile ||
      //     (imagePreview != null &&
      //       imagePreview?.substring(imagePreview.indexOf("/uploads")))
      // );
      if (selectedFile) {
        formData.append("BackGroundImages", selectedFile);
      } else if (imagePreview && imagePreview?.includes("/uploads")) {
        const imagePath = imagePreview?.substring(
          imagePreview.indexOf("/uploads")
        );
        formData.append("BackGroundImages", imagePath);
      }

      formData.append("HeadingColour", headingColor);
      formData.append("Position_Bgcolour", positionBGColor);

      let responseMessage = "";

      if (editItemId) {
        await privateRequest.put(
          `ServiceShortcutHeading/ShortcutHeading/${editItemId}`,
          formData
        );
        responseMessage = "updated";
      } else {
        await privateRequest.post(
          `ServiceShortcutHeading/ShortcutHeading`,
          formData
        );
        responseMessage = "added";
      }
      getServiceShorcutHeading();
      setShowModal(false);
      setHeading("");
      setStatus("");
      setVisible(false);
      setColor("fff");
      setheadingColor("fff");
      setPositionBGColor("");
      setSelectedFile("");
      setImagePreview("");
      setEditItemId(null);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: ` Shortcut Section ${responseMessage} successfully!`,
      });
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.message,
      });
    }
  };

  useEffect(() => {
    getServiceShorcutHeading();
  }, []);

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    // Initialize items state with gettservice
    setItems(gettservice);
  }, [gettservice]);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const reorderedItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );
    setItems(reorderedItems);

    // Call the function to update the backend
    await UpdateServiceShortcutHeadingPosition(reorderedItems);
  };

  const UpdateServiceShortcutHeadingPosition = async (updatedItems) => {
    try {
      let responseMessage = "";
      let response = [];
      let formData = updatedItems?.map((item, index) => ({
        id: item?._id,
        newIndex: index + 1,
      }));
      if (editItemId) {
        response = await privateRequest.put(
          `ServiceShortcutHeading/updateMultipleInd`,
          formData
        );
        responseMessage = "updated";
      } else {
        response = await privateRequest.post(
          `ServiceShortcutHeading/updateMultipleInd`,
          formData
        );
        responseMessage = "added";
      }
      getServiceShorcutHeading();

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: response.data.message,
      });
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
    }
  };

  return (
    <>
      {gettservice.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Shortcut Heading</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setShowModal(true);
                        setHeading("");
                        setStatus("");
                        setVisible(false);
                        setColor("#ffffff");
                        setSelectedFile("");
                        setImagePreview("");
                        setMarginBottom(0);
                        setMarginTop(0);
                        setPaddingBottom(0);
                        setPaddingTop(0);
                        setheadingColor("#ffffff");
                        setPositionBGColor("");
                        setSubHeading("");
                        setEditItemId(null);
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>

                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable">
                          {(provided) => (
                            <table
                              className="table table-striped table-hover table-sm"
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              <thead className="bg-primary text-white">
                                <tr>
                                  <th scope="col">Sr No</th>
                                  <th scope="col">Heading</th>
                                  <th scope="col">SubHeading</th>
                                  <th scope="col">Image</th>
                                  <th scope="col">Status</th>
                                  <th scope="col">Visible</th>
                                  <th scope="col">Background Color</th>
                                  <th scope="col">Created</th>
                                  <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {items.length > 0 &&
                                  items.map((item, index) => (
                                    <Draggable
                                      key={item._id}
                                      draggableId={item._id}
                                      index={index}
                                    >
                                      {(provided) => (
                                        <tr
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                        >
                                          <td className="align-center">
                                            {index + 1}
                                          </td>
                                          <td className="align-center">
                                            {item?.Heading}
                                          </td>
                                          <td className="align-center">
                                            {item?.SubHeading}
                                          </td>
                                          <td className="align-center">
                                            {item?.BackGroundImages && (
                                              <img
                                                src={`${Image_URL}${item?.BackGroundImages}`}
                                                className="rounded-pill"
                                                height="50"
                                                width="50"
                                              />
                                            )}
                                          </td>
                                          <td>
                                            <span
                                              className={`badge ${
                                                item?.Status.toString() ===
                                                "true"
                                                  ? "badge-primary"
                                                  : "badge-danger"
                                              }`}
                                            >
                                              {item?.Status.toString() ===
                                              "true"
                                                ? "Active"
                                                : "Inactive"}
                                            </span>
                                          </td>
                                          <td>
                                            <span
                                              className={`badge ${
                                                item?.Visible?.toString() ===
                                                "true"
                                                  ? "badge-primary"
                                                  : "badge-danger"
                                              }`}
                                            >
                                              {item?.Visible?.toString() ===
                                              "true"
                                                ? "Visible"
                                                : "Invisible"}
                                            </span>
                                          </td>
                                          <td>
                                            <div
                                              style={{
                                                height: "30px",
                                                width: "40px",
                                                backgroundColor:
                                                  item?.BackGroundColour,
                                              }}
                                            />
                                          </td>
                                          <td className="align-center">
                                            <p className="mb-0">
                                              {item.CreatedBy?.name}
                                            </p>
                                            <p className="mb-0">
                                              {new Date(
                                                item.createdAt
                                              ).toLocaleDateString("en-US", {
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric",
                                              })}
                                            </p>
                                          </td>
                                          <td className="align-center">
                                            <div className="btn-group">
                                              <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() => {
                                                  setEditItemId(item._id);
                                                  setHeading(item.Heading);
                                                  setSubHeading(
                                                    item.SubHeading
                                                  );
                                                  setStatus(
                                                    item.Status ? "1" : "0"
                                                  );
                                                  setVisible(
                                                    item?.Visible ? "1" : "0"
                                                  );
                                                  setColor(
                                                    item?.BackGroundColour
                                                  );
                                                  setMarginBottom(
                                                    item?.marginBottom || 0
                                                  );
                                                  setMarginTop(
                                                    item?.marginTop || 0
                                                  );
                                                  if (
                                                    item?.BackGroundImages
                                                      .length > 0
                                                  ) {
                                                    setImagePreview(
                                                      Image_URL +
                                                        item?.BackGroundImages
                                                    );
                                                  }
                                                  setheadingColor(
                                                    item?.HeadingColour
                                                  );
                                                  setPositionBGColor(
                                                    item?.Position_Bgcolour
                                                  );
                                                  setShowModal(true);
                                                }}
                                                data-toggle="modal"
                                                data-target="#addAreaModal"
                                              >
                                                <i className="fa fa-edit"></i>
                                              </button>
                                              <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() =>
                                                  DeleteService(item._id)
                                                }
                                              >
                                                <i className="fa fa-trash"></i>
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </tbody>
                            </table>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* All Modals */}

      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addHeroSliderModal"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Shortcut Heading
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddServiceShortcutHeading}>
                <div className="form-group">
                  <label className="mb-0">Heading</label>
                  <input
                    type="text"
                    id="inputgroupName"
                    className="form-control"
                    placeholder="Heading"
                    required
                    value={Heading}
                    onChange={(e) => setHeading(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Sub Heading</label>
                  <input
                    type="text"
                    id="inputgroupName"
                    className="form-control"
                    placeholder="Sub Heading"
                    required
                    value={SubHeading}
                    onChange={(e) => setSubHeading(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Heading Color</label>
                  <input
                    type="color"
                    className="form-control"
                    value={headingColor}
                    onChange={(e) => setheadingColor(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Margin Top</label>
                  <input
                    type="number"
                    id="inputgroupName"
                    className="form-control"
                    required
                    value={marginTop}
                    onChange={(e) => setMarginTop(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Margin Bottom</label>
                  <input
                    type="number"
                    id="inputgroupName"
                    className="form-control"
                    required
                    value={marginBottom}
                    onChange={(e) => setMarginBottom(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Padding Bottom</label>
                  <input
                    type="number"
                    id="inputgroupName"
                    className="form-control"
                    required
                    value={paddingBottom}
                    onChange={(e) => setPaddingBottom(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Padding Top</label>
                  <input
                    type="number"
                    id="inputgroupName"
                    className="form-control"
                    required
                    value={paddingTop}
                    onChange={(e) => setPaddingTop(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Background Color</label>
                  <input
                    type="color"
                    className="form-control"
                    value={color}
                    defaultValue={"#ffffff"}
                    onChange={(e) => setColor(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Background Color Type</label>
                  <select
                    className="form-control"
                    required
                    value={positionBGColor}
                    onChange={(e) => setPositionBGColor(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="half">Half</option>
                    <option value="full">Full</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="mb-0">Visible</label>
                  <select
                    className="form-control"
                    required
                    value={visible}
                    onChange={(e) => setVisible(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="mb-0">Status</label>
                  <select
                    className="form-control"
                    required
                    value={Status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
                <div className="form-group w-25">
                  <CustomImage
                    imagePreview={imagePreview}
                    setImagePreview={setImagePreview}
                    setSelectedFile={setSelectedFile}
                  />
                </div>

                <div className="form-group text-left">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default ServiceShortcutHeading;
